import { OrderedMap } from 'immutable'
import { normalize, schema } from 'normalizr'
import { createReducer } from '@cheesecakelabs/boilerplate/utils'

import { GET_RECONCILE_ITEMS, CHECK_RECONCILE_ITEM } from './actions'

export const INITIAL_STATE = new OrderedMap()

export const reconcileSchema = new schema.Entity('reconcile', {}, { idAttribute: 'startedAt' })

export const reconcile = createReducer(INITIAL_STATE, {
  [GET_RECONCILE_ITEMS.FULFILLED]: (state, { payload }) =>
    new OrderedMap(normalize(payload, [reconcileSchema]).entities.reconcile),

  [CHECK_RECONCILE_ITEM.FULFILLED]: (state, { payload }) =>
    new OrderedMap(normalize(payload, [reconcileSchema]).entities.reconcile),
})



// WEBPACK FOOTER //
// ./src/modules/reconcile/reducers.js